// ----------------------------------------------------------------------
// <copyright file="Izenda.Security.ConfigTenant.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Security Config Tenant Component
 */
!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');

  var Panel = require('share/components/controls/Izenda.Panel');
  var Button = require('share/components/controls/Izenda.Button');
  var Select = require('share/components/controls/multiSelectBox/Izenda.Select');
  var ErrorContainer = require('share/components/controls/Izenda.ErrorContainer');
  var EventsUtils = require('EventUtils');
  var action = require('./Izenda.SecurityConfigTenantAction');
  const { isEmpty } = require('lodash/fp');
  var SecurityConfigTenant = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    onClickResetTenantFieldValue: function() {
      this.props.store.model.resetTenantFieldValue();
    },

    renderTenantField: function() {
      var props = this.props;
      var store = props.store;
      var model = store.model;
      var notifyChange = EventsUtils.notifyChange;
      var bundle = store.getBundle();

      var systemField = function() {
        var fields = model.getSystemTenantFields();
        if (model.isSystemMode || isEmpty(fields)) {
          return null;
        } else {
          return <div className="field-center">{bundle.LABEL.SYSTEM_TENANT_FIELD_LABEL + fields}</div>;
        }
      };

      return (
        <div className="form-group u_fullHeight">
          <label className="col-md-7 col-xs-6 field-name control-label">
            <span>{bundle.LABEL.TENANT_FIELD_LABEL}</span>
            <i className="icon-info-circled" title={bundle.TOOLTIP.TENANT_TOOLTIP} />
          </label>
          <div className="col-md-5 col-xs-6 tenant-fields">
            <div className="col-md-10 u_inlineBlock no-padding">
              {systemField()}
              <Select
                value={model.tenantFieldValue}
                multi
                delimiter=";"
                simpleValue
                joinValues
                onAddNew={props.addNewTenantField}
                options={props.getTenantFieldOptions(model.tenantFieldValue)}
                onBlur={props.blurTenantField}
                onChange={props.changeTenantField}
                onBlurResetsInput={false}
                noResultsText={bundle.TEXT.TENANT_FIELD_NO_RESULT_TEXT}
                isInsertOnBlur
                textboxMode
                subClassName="u_fullHeight"
              />
            </div>
            <div className="col-md-2 col-xs-1 control-label">
              <i
                className="icon-ccw reset-tenant-field"
                title={bundle.TOOLTIP.RESET_TENANT_FIELD_TOOLTIP}
                onClick={this.onClickResetTenantFieldValue}
              />
            </div>
          </div>
        </div>
      );
    },

    render: function() {
      var store = this.props.store;
      var model = store.model;
      var notifyChange = EventsUtils.notifyChange;
      var bundle = store.getBundle();

      return (
        <div className="form-horizontal">
          <div className="form-group">
            <label className="col-md-7 col-xs-6 control-label field-name">
              <span>{bundle.LABEL.SHOW_TENANT_FIELD_LABEL}</span>
              <i className="icon-info-circled" title={bundle.TOOLTIP.SHOW_TENANT_TOOLTIP} />
            </label>
            <div className="col-md-5 col-xs-6">
              <input
                type="checkbox"
                className="show-tenant-field"
                checked={model.showTenantFieldValue}
                onChange={notifyChange(model.updateShowTenantField.bind(model), EventsUtils.CHECKBOX)}
              />
            </div>
          </div>
          {this.renderTenantField()}
        </div>
      );
    }
  });

  module.exports = connect(action)(SecurityConfigTenant);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/Izenda.SecurityConfigTenant.jsx